import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { usePatientMutation } from '../../api/patient/usePatientMutation';
import { FormError } from '../form/FormError';
import { TextField } from "@mui/material";
export const PatientInlineDiagnosisForm = (props) => {
    const { onComplete, initialValue, patientId, initialEditing } = props;
    const { mutateAsync } = usePatientMutation();
    const [isEditing, setIsEditing] = useState(initialEditing);
    const { handleSubmit, register, formState: { errors }, } = useForm({
        defaultValues: {
            diagnosis: initialValue,
        },
    });
    const onSubmit = async (data) => {
        if (data.diagnosis !== initialValue) {
            if (data.diagnosis === '') {
                data.diagnosis = 'null';
                await mutateAsync({ patientId, ...data });
                data.diagnosis = '';
            }
            else {
                await mutateAsync({ patientId, ...data });
            }
            onComplete(data.diagnosis);
        }
    };
    return (React.createElement("form", { onSubmit: handleSubmit(onSubmit), noValidate: true, style: {
            borderRadius: '4px',
            border: isEditing ? '1px solid #2C78EB' : 'none',
            padding: isEditing ? '5px' : '0px'
        } },
        React.createElement("div", { className: "text-sm flex items-center", style: { height: '30px' } },
            React.createElement(TextField, { ...register('diagnosis'), id: "user-diagnosis", variant: 'standard', style: { fontSize: 11, color: 'rgba(0, 0, 0, 0.87)', fontFamily: 'Barlow', fontWeight: '400', width: '100%', verticalAlign: 'middle', marginRight: isEditing ? '5px' : '45px' }, size: 'small', inputProps: { style: { height: '10px', fontSize: 12 } }, placeholder: 'N/A', onClick: () => setIsEditing(true), InputProps: {
                    disableUnderline: true,
                    readOnly: !isEditing, // disable editing when not in edit mode
                }, onBlur: (e) => {
                    const currentValue = e.target.value;
                    setIsEditing(false);
                    if (currentValue === initialValue) {
                        props.onCancel();
                    }
                    else {
                        handleSubmit(onSubmit)();
                    }
                } })),
        React.createElement(FormError, { errors: errors, name: "mrn", className: "font-bold text-app-red-dark block text-sm mt-1" })));
};
